import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { FolderNode } from '@teetsh/app/src/types/sequences';

export const SEQUENCES_LIST_KEY = 'sequencesData';

function getSequencesFolders() {
  return request('/sequences/hierarchy', {
    method: 'GET',
  }).then<FolderNode[]>(res => res.data || []);
}

export default function useSequencesFolders() {
  return useQuery({
    queryKey: [SEQUENCES_LIST_KEY],
    queryFn: getSequencesFolders,
    // staleTime: 1000 * 60 * 60,
    refetchOnWindowFocus: true,
  });
}
